export default __webpack_public_path__ + "static/media/mapColEpm.febb6e15.png";